// Skeleton placeholder used while listing carousels are fetching.
// Mirrors .prop-card's exact dimensions so swapping in real cards causes
// zero layout shift. Animated shimmer is pure CSS — no JS state.
import React from 'react';
import './PropertyCardSkeleton.css';

export default function PropertyCardSkeleton() {
  return (
    <div className="prop-card prop-card-skel" aria-hidden="true">
      <div className="prop-card__thumb prop-card-skel__thumb" />
      <div className="prop-card__body">
        <div className="prop-card-skel__line prop-card-skel__line--kicker" />
        <div className="prop-card-skel__line prop-card-skel__line--title" />
        <div className="prop-card-skel__line prop-card-skel__line--loc" />
        <div className="prop-card-skel__line prop-card-skel__line--specs" />
        <div className="prop-card-skel__footer">
          <div className="prop-card-skel__line prop-card-skel__line--price" />
          <div className="prop-card-skel__line prop-card-skel__line--view" />
        </div>
      </div>
    </div>
  );
}
